export var BannerThemes;
(function (BannerThemes) {
    BannerThemes["light"] = "light";
    BannerThemes["aubergineTint"] = "aubergineTint";
    BannerThemes["aubergineTintLight"] = "aubergineTintLight";
    BannerThemes["superDarkMint"] = "superDarkMint";
    BannerThemes["superDarkCyan"] = "superDarkCyan";
    BannerThemes["amber"] = "amber";
    BannerThemes["amberTint"] = "amberTint";
    BannerThemes["cyanTint"] = "cyanTint";
    BannerThemes["paleGrey"] = "paleGrey";
    BannerThemes["mintTint"] = "mintTint";
})(BannerThemes || (BannerThemes = {}));
export var RadioTheme;
(function (RadioTheme) {
    RadioTheme["Light"] = "light";
    RadioTheme["Dark"] = "dark";
})(RadioTheme || (RadioTheme = {}));
export var CheckButtonTheme;
(function (CheckButtonTheme) {
    CheckButtonTheme["Light"] = "light";
    CheckButtonTheme["Dark"] = "dark";
})(CheckButtonTheme || (CheckButtonTheme = {}));
